import { PRIMARY_AUTH_STORAGE_PREFIX } from "Constants/AuthConstants";

export const clearPrimaryStorage = () => {
  Object.keys(sessionStorage)
    .filter((key) => key.startsWith(PRIMARY_AUTH_STORAGE_PREFIX))
    .forEach((key) => sessionStorage.removeItem(key));
};
